// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__39uB_","alertIcon":"ConfirmModal_alertIcon__37NcG"};